module.exports = __webpack_public_path__ + "static/media/sign.fee82ee2.png";